module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-a413c00826b6b3e8ac43f6b629dc7fa1.png";